import { useContext } from "react"
import { motion } from "motion/react"

import Letter from "./Letter"
import { AppContext } from "../App"
import { LetterStatus, MAX_ATTEMPTS } from "../helpers"

function Board() {
  const { settings, currAttempt, shakeState, boardStatus } = useContext(AppContext)

  return (
    <div className="board">
      {Array.from({ length: MAX_ATTEMPTS }, (_, attemptIndex) => {
        const isShakingRow =
          shakeState.row === attemptIndex &&
          shakeState.token > 0 &&
          currAttempt.attempt === attemptIndex
        const isWinningRow =
          boardStatus[attemptIndex].every(
            (status) => status === LetterStatus.LetterAndPosition
          )

        return (
          <motion.div
            className={`row ${isWinningRow ? "win-row" : ""}`.trim()}
            style={{ ["--letters" as string]: settings.wordLength }}
            key={`${attemptIndex}-${isShakingRow ? shakeState.token : 0}-${isWinningRow ? "win" : "base"}`}
            animate={
              isShakingRow
                ? { x: [0, -8, 8, -6, 6, -3, 3, 0] }
                : isWinningRow
                  ? {
                      x: 0,
                      scale: [1, 1.015, 1],
                    }
                  : { x: 0, scale: 1 }
            }
            transition={{ duration: isWinningRow ? 1.95 : 0.35 }}
          >
            {Array.from({ length: settings.wordLength }, (_, letterPos) => (
              <Letter
                key={`${attemptIndex}-${letterPos}`}
                letterPos={letterPos}
                attemptVal={attemptIndex}
              />
            ))}
          </motion.div>
        )
      })}
    </div>
  )
}

export default Board
